import { render, staticRenderFns } from "./ActionIcons.vue?vue&type=template&id=36e8a985&scoped=true"
import script from "./ActionIcons.vue?vue&type=script&lang=js"
export * from "./ActionIcons.vue?vue&type=script&lang=js"
import style0 from "./ActionIcons.vue?vue&type=style&index=0&id=36e8a985&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8a985",
  null
  
)

export default component.exports